import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { Paper } from "@material-ui/core";
import { Spinner } from "react-bootstrap";
import ReactToPrint from "react-to-print";
import ReactApexChart from "react-apexcharts";
import { DownloadTableExcel } from "react-export-table-to-excel";
import { useAlert } from "react-alert";
import { upperCase } from "lodash";
import { baseUrl, config } from "../../../services/config";

const normalizeReportData = (responseData) => {
  if (Array.isArray(responseData)) return responseData;
  const payload = responseData?.payload ?? responseData;
  if (Array.isArray(payload)) return payload;
  if (payload?.month && Array.isArray(payload?.data)) return [payload];
  if (Array.isArray(payload?.data)) return payload.data;
  return [];
};

const dummyReportData = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
].map((monthName, monthIndex) => ({
  month: `${monthName} 2026`,
  data: [1, 2, 3, 4, 5].map((dummyBranchId) => {
    const totalInquiries = (((monthIndex + 2) * (dummyBranchId + 3)) % 19) + 3;
    const conversionRate = 0.42 + dummyBranchId * 0.08;
    return {
      branch_id: dummyBranchId,
      total_inquiries: totalInquiries,
      total_converted: Math.min(
        totalInquiries,
        Math.round(totalInquiries * conversionRate),
      ),
    };
  }),
}));

const monthInputToLabel = (value) => {
  if (!value) return "";
  const [year, month] = value.split("-");
  const label = new Date(
    Number(year),
    Number(month) - 1,
    1,
  ).toLocaleString("en-US", { month: "short" });
  return `${label} ${year}`;
};

const getMonthName = (date) => {
  const monthNames = [
    "January", // index 0
    "February", // index 1
    "March", // index 2
    "April", // index 3
    "May", // index 4
    "June", // index 5
    "July", // index 6
    "August", // index 7
    "September", // index 8
    "October", // index 9
    "November", // index 10
    "December", // index 11
  ];
  const d = new Date(date);

  return `${monthNames[d.getMonth()]}, ${d.getFullYear()}`;
};

// const dummyData = [
//   {
//     month: "Jan 2026",
//     data: [
//       { branch_id: 2, total_inquiries: 3, total_converted: 1 },
//       { branch_id: 3, total_inquiries: 7, total_converted: 4 },
//       { branch_id: 4, total_inquiries: 2, total_converted: 1 },
//       { branch_id: 5, total_inquiries: 6, total_converted: 3 },
//       { branch_id: 6, total_inquiries: 4, total_converted: 2 },
//       { branch_id: 8, total_inquiries: 5, total_converted: 2 },
//       { branch_id: 9, total_inquiries: 8, total_converted: 5 },
//       { branch_id: 10, total_inquiries: 1, total_converted: 0 },
//     ],
//   },
//   {
//     month: "Feb 2026",
//     data: [
//       { branch_id: 2, total_inquiries: 4, total_converted: 2 },
//       { branch_id: 3, total_inquiries: 8, total_converted: 5 },
//       { branch_id: 4, total_inquiries: 3, total_converted: 1 },
//       { branch_id: 5, total_inquiries: 7, total_converted: 4 },
//       { branch_id: 6, total_inquiries: 5, total_converted: 2 },
//       { branch_id: 8, total_inquiries: 2, total_converted: 1 },
//       { branch_id: 9, total_inquiries: 9, total_converted: 6 },
//       { branch_id: 10, total_inquiries: 6, total_converted: 3 },
//     ],
//   },
//   {
//     month: "Mar 2026",
//     data: [
//       { branch_id: 2, total_inquiries: 5, total_converted: 2 },
//       { branch_id: 3, total_inquiries: 10, total_converted: 6 },
//       { branch_id: 4, total_inquiries: 4, total_converted: 2 },
//       { branch_id: 5, total_inquiries: 9, total_converted: 5 },
//       { branch_id: 6, total_inquiries: 6, total_converted: 3 },
//       { branch_id: 8, total_inquiries: 3, total_converted: 1 },
//       { branch_id: 9, total_inquiries: 11, total_converted: 7 },
//       { branch_id: 10, total_inquiries: 8, total_converted: 4 },
//     ],
//   },
//   {
//     month: "Apr 2026",
//     data: [
//       { branch_id: 2, total_inquiries: 6, total_converted: 3 },
//       { branch_id: 3, total_inquiries: 9, total_converted: 5 },
//       { branch_id: 4, total_inquiries: 5, total_converted: 2 },
//       { branch_id: 5, total_inquiries: 8, total_converted: 4 },
//       { branch_id: 6, total_inquiries: 7, total_converted: 3 },
//       { branch_id: 8, total_inquiries: 4, total_converted: 2 },
//       { branch_id: 9, total_inquiries: 10, total_converted: 6 },
//       { branch_id: 10, total_inquiries: 7, total_converted: 3 },
//     ],
//   },
//   {
//     month: "May 2026",
//     data: [
//       { branch_id: 2, total_inquiries: 7, total_converted: 3 },
//       { branch_id: 3, total_inquiries: 12, total_converted: 7 },
//       { branch_id: 4, total_inquiries: 6, total_converted: 3 },
//       { branch_id: 5, total_inquiries: 10, total_converted: 6 },
//       { branch_id: 6, total_inquiries: 8, total_converted: 4 },
//       { branch_id: 8, total_inquiries: 5, total_converted: 2 },
//       { branch_id: 9, total_inquiries: 13, total_converted: 8 },
//       { branch_id: 10, total_inquiries: 9, total_converted: 5 },
//     ],
//   },
//   {
//     month: "Jun 2026",
//     data: [
//       { branch_id: 2, total_inquiries: 8, total_converted: 4 },
//       { branch_id: 3, total_inquiries: 11, total_converted: 6 },
//       { branch_id: 4, total_inquiries: 7, total_converted: 3 },
//       { branch_id: 5, total_inquiries: 12, total_converted: 7 },
//       { branch_id: 6, total_inquiries: 9, total_converted: 4 },
//       { branch_id: 8, total_inquiries: 6, total_converted: 3 },
//       { branch_id: 9, total_inquiries: 14, total_converted: 9 },
//       { branch_id: 10, total_inquiries: 10, total_converted: 5 },
//     ],
//   },
//   {
//     month: "Jul 2026",
//     data: [
//       { branch_id: 2, total_inquiries: 9, total_converted: 4 },
//       { branch_id: 3, total_inquiries: 13, total_converted: 8 },
//       { branch_id: 4, total_inquiries: 8, total_converted: 4 },
//       { branch_id: 5, total_inquiries: 11, total_converted: 6 },
//       { branch_id: 6, total_inquiries: 10, total_converted: 5 },
//       { branch_id: 8, total_inquiries: 7, total_converted: 3 },
//       { branch_id: 9, total_inquiries: 15, total_converted: 10 },
//       { branch_id: 10, total_inquiries: 11, total_converted: 6 },
//     ],
//   },
//   {
//     month: "Aug 2026",
//     data: [
//       { branch_id: 2, total_inquiries: 10, total_converted: 5 },
//       { branch_id: 3, total_inquiries: 14, total_converted: 8 },
//       { branch_id: 4, total_inquiries: 9, total_converted: 4 },
//       { branch_id: 5, total_inquiries: 13, total_converted: 7 },
//       { branch_id: 6, total_inquiries: 11, total_converted: 5 },
//       { branch_id: 8, total_inquiries: 8, total_converted: 4 },
//       { branch_id: 9, total_inquiries: 16, total_converted: 10 },
//       { branch_id: 10, total_inquiries: 12, total_converted: 7 },
//     ],
//   },
//   {
//     month: "Sep 2026",
//     data: [
//       { branch_id: 2, total_inquiries: 8, total_converted: 4 },
//       { branch_id: 3, total_inquiries: 12, total_converted: 7 },
//       { branch_id: 4, total_inquiries: 7, total_converted: 3 },
//       { branch_id: 5, total_inquiries: 11, total_converted: 6 },
//       { branch_id: 6, total_inquiries: 9, total_converted: 4 },
//       { branch_id: 8, total_inquiries: 6, total_converted: 3 },
//       { branch_id: 9, total_inquiries: 14, total_converted: 9 },
//       { branch_id: 10, total_inquiries: 10, total_converted: 5 },
//     ],
//   },
//   {
//     month: "Oct 2026",
//     data: [
//       { branch_id: 2, total_inquiries: 7, total_converted: 3 },
//       { branch_id: 3, total_inquiries: 11, total_converted: 6 },
//       { branch_id: 4, total_inquiries: 6, total_converted: 2 },
//       { branch_id: 5, total_inquiries: 10, total_converted: 5 },
//       { branch_id: 6, total_inquiries: 8, total_converted: 4 },
//       { branch_id: 8, total_inquiries: 5, total_converted: 2 },
//       { branch_id: 9, total_inquiries: 13, total_converted: 8 },
//       { branch_id: 10, total_inquiries: 9, total_converted: 4 },
//     ],
//   },
//   {
//     month: "Nov 2026",
//     data: [
//       { branch_id: 2, total_inquiries: 6, total_converted: 3 },
//       { branch_id: 3, total_inquiries: 10, total_converted: 5 },
//       { branch_id: 4, total_inquiries: 5, total_converted: 2 },
//       { branch_id: 5, total_inquiries: 9, total_converted: 4 },
//       { branch_id: 6, total_inquiries: 7, total_converted: 3 },
//       { branch_id: 8, total_inquiries: 4, total_converted: 2 },
//       { branch_id: 9, total_inquiries: 12, total_converted: 7 },
//       { branch_id: 10, total_inquiries: 8, total_converted: 4 },
//     ],
//   },
//   {
//     month: "Dec 2026",
//     data: [
//       { branch_id: 2, total_inquiries: 5, total_converted: 2 },
//       { branch_id: 3, total_inquiries: 9, total_converted: 5 },
//       { branch_id: 4, total_inquiries: 4, total_converted: 1 },
//       { branch_id: 5, total_inquiries: 8, total_converted: 4 },
//       { branch_id: 6, total_inquiries: 6, total_converted: 3 },
//       { branch_id: 8, total_inquiries: 3, total_converted: 1 },
//       { branch_id: 9, total_inquiries: 11, total_converted: 6 },
//       { branch_id: 10, total_inquiries: 7, total_converted: 3 },
//     ],
//   },
// ];

const BranchMonthlyInquiries = () => {
  const alert = useAlert();
  const authtoken = localStorage.getItem("userToken");
  const componentRef = useRef(null);
  const onBeforeGetContentResolve = React.useRef(null);
  const [printloading, setprintloading] = React.useState(false);
  const [text, setText] = React.useState("old boring text");
  console.log(text);
  const todayDate = () => {
    let d = new Date();
    var curr_moth = ("0" + (d.getMonth() + 1)).slice(-2);
    var curr_date = ("0" + d.getDate()).slice(-2);
    let newdate = `${d.getFullYear()}-${curr_moth}-${curr_date}`;
    return newdate;
  };
  const [exportTableElement, setExportTableElement] = useState(null);
  const [reportData, setReportData] = useState([]);
  const [branches, setBranches] = useState([]);
  const [sessions, setSessions] = useState([]);
  const [sessionId, setSessionId] = useState("");
  const [sessionName, setSessionName] = useState("");
  const [month, setMonth] = useState("");
  const [branchId, setBranchId] = useState("");
  const [loading, setLoading] = useState(false);
  const [exportLoading, setExportLoading] = useState(false);
  const [unitName, setUnitName] = useState("");
  const [logo, setLogo] = useState("");

  const getBranches = useCallback(async () => {
    try {
      const response = await fetch(`${baseUrl}/view-branch-url`, {
        headers: { Authorization: `Bearer ${authtoken}` },
      });
      const data = await response.json();
      if (response.ok && data?.metadata?.success !== false) {
        setBranches(data?.payload || []);
      }
    } catch (error) {
      alert.error("Unable to load branches");
    }
  }, [alert, authtoken]);

  const getSettings = useCallback(async () => {
    try {
      const response = await fetch(`${baseUrl}/get-settings`, {
        headers: { Authorization: `Bearer ${authtoken}` },
      });
      const data = await response.json();
      if (response.ok && data?.metadata?.success !== false) {
        setUnitName(upperCase(data?.payload?.settings?.unit_name || ""));
        setLogo(data?.payload?.settings?.logo_file || "");
      }
    } catch (error) {
      // The report can still be viewed without school branding.
    }
  }, [authtoken]);

  const getSessions = useCallback(async () => {
    try {
      const response = await fetch(`${baseUrl}/session`, {
        headers: { Authorization: `Bearer ${authtoken}` },
      });
      const data = await response.json();
      if (response.ok && data?.metadata?.success !== false) {
        setSessions(data?.payload || []);
        data.payload.forEach((session, index) => {
          if (String(session.active_academic_year) === "1") {
            setSessionId(session.id);
            setSessionName(session.year);
          }
        });
      }
    } catch (error) {
      alert.error("Unable to load sessions");
    }
  }, [alert, authtoken]);

  useEffect(() => {
    getBranches();
    getSettings();
    getSessions();
  }, [getBranches, getSessions, getSettings]);

  const getFilteredDummyData = () => {
    const monthLabel = monthInputToLabel(month);
    let records = dummyReportData.filter(
      (record) => !monthLabel || record.month === monthLabel,
    );
    if (monthLabel && !records.length) {
      records = [{ ...dummyReportData[0], month: monthLabel }];
    }
    return records.map((record) => ({
      ...record,
      data: branchId
        ? [
            record.data.find(
              (item) => String(item.branch_id) === String(branchId),
            ) || {
              branch_id: Number(branchId),
              total_inquiries: 5,
              total_converted: 2,
            },
          ]
        : record.data,
    }));
  };

  const getReport = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${baseUrl}/crm-branch-inquiries`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${authtoken}`,
        },
        body: JSON.stringify({
          month: month || null,
          branch_id: branchId ? Number(branchId) : null,
          year_id: sessionId ? Number(sessionId) : null,
        }),
      });
      const data = await response.json();
      if (!response.ok || data?.metadata?.success === false) {
        alert.error(
          data?.metadata?.message ||
            "Unable to load inquiry report; showing test data",
        );
        setReportData(getFilteredDummyData());
        return;
      }
      const normalizedData = normalizeReportData(data);
      //   const normalizedData = normalizeReportData(dummyData);
      setReportData(
        normalizedData.length ? normalizedData : getFilteredDummyData(),
      );
    } catch (error) {
      alert.error("Unable to load inquiry report; showing test data");
      setReportData(getFilteredDummyData());
    } finally {
      setLoading(false);
    }
  };

  const reportBranchIds = useMemo(() => {
    const ids = new Set();
    reportData.forEach((monthRecord) => {
      (monthRecord?.data || []).forEach((record) => {
        if (record?.branch_id !== null && record?.branch_id !== undefined) {
          ids.add(String(record.branch_id));
        }
      });
    });
    return Array.from(ids);
  }, [reportData]);

  const visibleBranches = useMemo(() => {
    const selectedIds = branchId ? [String(branchId)] : reportBranchIds;
    return selectedIds.map((id) => {
      const branch = branches.find((item) => String(item.id) === id);
      return {
        id,
        name:
          branch?.branches ||
          branch?.branch_name ||
          branch?.name ||
          `Branch ${id}`,
      };
    });
  }, [branchId, branches, reportBranchIds]);

  const getBranchRecord = (monthRecord, id) =>
    (monthRecord?.data || []).find(
      (record) => String(record.branch_id) === String(id),
    ) || { total_inquiries: 0, total_converted: 0 };

  const branchTotals = useMemo(
    () =>
      visibleBranches.map((branch) =>
        reportData.reduce(
          (totals, monthRecord) => {
            const record = getBranchRecord(monthRecord, branch.id);
            return {
              inquiries: totals.inquiries + Number(record.total_inquiries || 0),
              converted: totals.converted + Number(record.total_converted || 0),
            };
          },
          { inquiries: 0, converted: 0 },
        ),
      ),
    [reportData, visibleBranches],
  );

  //for print
  const handleBeforePrint = React.useCallback(() => {
    console.log("`onBeforePrint` called");
  }, []);

  const handleOnBeforeGetContent = React.useCallback(() => {
    console.log("`onBeforeGetContent` called");
    setprintloading(true);
    setText("Loading new text...");

    return new Promise((resolve) => {
      onBeforeGetContentResolve.current = resolve;

      setTimeout(() => {
        setprintloading(false);
        setText("New, Updated Text!");
        resolve();
      }, 2000);
    });
  }, [setprintloading, setText]);

  const handleAfterPrint = React.useCallback(() => {
    console.log("`onAfterPrint` called");
  }, []);

  const conversionRatio = (total) =>
    total.inquiries > 0
      ? `${Math.round((total.converted / total.inquiries) * 100)}%`
      : "0%";

  const conversionRatioValue = (total) =>
    total.inquiries > 0
      ? Math.round((total.converted / total.inquiries) * 100)
      : 0;

  const chartOptions = useMemo(
    () => ({
      chart: { type: "bar", toolbar: { show: false } },
      plotOptions: {
        bar: { distributed: true, columnWidth: "45%", borderRadius: 2 },
      },
      dataLabels: {
        enabled: true,
        formatter: (value) => `${value}%`,
      },
      xaxis: {
        categories: visibleBranches.map((branch) => branch.name),
      },
      yaxis: {
        min: 0,
        max: 100,
        labels: { formatter: (value) => `${Math.round(value)}%` },
        title: { text: "Conversion Ratio" },
      },
      legend: { show: false },
      title: { text: "Conversion Ratio", align: "center" },
      colors: [
        "#197c9e",
        "#c90000",
        "#245b17",
        "#f39c12",
        "#6f42c1",
        "#FF5722",
        "#F44336",
        "#E91E63",
        "#4e6e29",
        "#828c1c",
        "#FFC107",
        "#FF9800",
      ],
    }),
    [visibleBranches],
  );

  const chartSeries = useMemo(
    () => [
      {
        name: "Conversion Ratio",
        data: branchTotals.map(conversionRatioValue),
      },
    ],
    [branchTotals],
  );

  const pageStyle = `
    @page {
      size: A4 landscape !important;
      margin: 8mm !important;
    }

    @media print {
      .branch-inquiry-print {
        visibility: visible !important;
        position: static !important;
      }

      .branch-inquiry-print-only {
        left: auto !important;
        top: auto !important;
        width: 100% !important;
      }
    }
  `;

  const startExport = () => {
    if (!exportTableElement || exportLoading) return;
    setExportLoading(true);
    window.setTimeout(() => setExportLoading(false), 1500);
  };

  const reportTable = (tableRef) => (
    <table
      ref={tableRef}
      className="table table-bordered mb-0"
      style={{ color: "#111", width: "100%" }}
    >
      <thead>
        <tr>
          <th
            rowSpan="2"
            className="text-center align-middle"
            style={{
              background: "#343434",
              color: "white",
              minWidth: 110,
              border: "1px solid #343434",
            }}
          >
            Month
          </th>
          <th
            colSpan={visibleBranches.length}
            className="text-center"
            style={{
              background: `${config?.navBarColor}`,
              color: "white",
              fontSize: "16px",
              border: `1px solid ${config?.navBarColor}`,
            }}
          >
            Inquiries
          </th>
          <th
            colSpan={visibleBranches.length}
            className="text-center"
            style={{
              background: `${config?.txtColor}`,
              color: "white",
              fontSize: "16px",
              border: `1px solid ${config?.txtColor}`,
            }}
          >
            Admissions
          </th>
        </tr>
        <tr>
          {visibleBranches.map((branch) => (
            <th
              key={`inquiry-${branch.id}`}
              className="text-center"
              style={{ border: "1px solid black" }}
            >
              {branch.name}
            </th>
          ))}
          {visibleBranches.map((branch) => (
            <th
              key={`admission-${branch.id}`}
              className="text-center"
              style={{ border: "1px solid black" }}
            >
              {branch.name}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {reportData.map((monthRecord, index) => (
          <tr key={`${monthRecord.month}-${index}`}>
            <th className="text-center" style={{ border: "1px solid black" }}>
              {monthRecord.month}
            </th>
            {visibleBranches.map((branch) => (
              <td
                key={`inq-${index}-${branch.id}`}
                className="text-center"
                style={{ border: "1px solid black" }}
              >
                {Number(
                  getBranchRecord(monthRecord, branch.id).total_inquiries || 0,
                )}
              </td>
            ))}
            {visibleBranches.map((branch) => (
              <td
                key={`adm-${index}-${branch.id}`}
                className="text-center"
                style={{ border: "1px solid black" }}
              >
                {Number(
                  getBranchRecord(monthRecord, branch.id).total_converted || 0,
                )}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
      <tfoot>
        <tr style={{ background: "#EBEDF3", fontWeight: "bold" }}>
          <th className="text-center" style={{ border: "1px solid black" }}>
            Total
          </th>
          {branchTotals.map((total, index) => (
            <td
              key={`total-inquiries-${visibleBranches[index].id}`}
              className="text-center"
              style={{ border: "1px solid black" }}
            >
              {total.inquiries}
            </td>
          ))}
          {branchTotals.map((total, index) => (
            <td
              key={`total-admissions-${visibleBranches[index].id}`}
              className="text-center"
              style={{ border: "1px solid black" }}
            >
              {total.converted}
            </td>
          ))}
        </tr>
        <tr style={{ fontWeight: "bold" }}>
          <th
            colSpan={visibleBranches.length + 1}
            className="text-center"
            style={{ color: `${config?.txtColor}`, border: "1px solid black" }}
          >
            Conversion Ratio
          </th>
          {branchTotals.map((total, index) => (
            <td
              key={`ratio-${visibleBranches[index].id}`}
              className="text-center"
              style={{ border: "1px solid black" }}
            >
              {conversionRatio(total)}
            </td>
          ))}
        </tr>
      </tfoot>
    </table>
  );

  return (
    <Paper style={{ marginTop: 10, marginBottom: 10, padding: 15 }}>
      <div className="row align-items-end">
        <div className="col-md-3 mb-3">
          <label className="form-control-label">
            <b>Select Session</b>
          </label>
          <select
            className="form-control form-select"
            value={sessionId}
            onChange={(event) => setSessionId(event.target.value)}
          >
            <option value="">All Sessions</option>
            {sessions.map((session) => (
              <option key={session.id} value={session.id}>
                {session.year || session.name || session.session_name}
              </option>
            ))}
          </select>
        </div>
        <div className="col-md-3 mb-3">
          <label className="form-control-label">
            <b>Select Month</b>
          </label>
          <input
            type="month"
            className="form-control"
            value={month}
            onChange={(event) => setMonth(event.target.value)}
          />
        </div>
        <div className="col-md-3 mb-3">
          <label className="form-control-label">
            <b>Select Branch</b>
          </label>
          <select
            className="form-control form-select"
            value={branchId}
            onChange={(event) => setBranchId(event.target.value)}
          >
            <option value="">All Branches</option>
            {branches.map((branch) => (
              <option key={branch.id} value={branch.id}>
                {branch.branches || branch.branch_name || branch.name}
              </option>
            ))}
          </select>
        </div>

        <div className="col-md-3 mb-3 d-flex">
          <button
            className="btn btn-primary mr-2"
            onClick={getReport}
            disabled={loading}
          >
            Show
          </button>
          {reportData.length > 0 && (
            <>
              <ReactToPrint
                documentTitle={`Branch Monthly Inquiry to Admissions Ratio`}
                pageStyle={pageStyle}
                onAfterPrint={handleAfterPrint}
                onBeforeGetContent={handleOnBeforeGetContent}
                onBeforePrint={handleBeforePrint}
                removeAfterPrint={true}
                trigger={() => (
                  <button
                    type="button"
                    className="btn btn-primary mr-2"
                    disabled={printloading || !componentRef.current}
                  >
                    {printloading ? "Printing..." : "Print"}
                  </button>
                )}
                content={() => componentRef.current}
              />
              <DownloadTableExcel
                filename="Inquiry to Admissions Ratio"
                sheet="Inquiry Admission Ratio"
                currentTableRef={exportTableElement}
              >
                <button
                  type="button"
                  className="btn btn-primary"
                  disabled={exportLoading || !exportTableElement}
                  onClick={startExport}
                >
                  {exportLoading ? "Exporting..." : "Export"}
                </button>
              </DownloadTableExcel>
            </>
          )}
        </div>
      </div>

      {loading && (
        <div className="text-center py-5">
          <Spinner animation="border" />
        </div>
      )}

      {!loading && reportData.length > 0 && visibleBranches.length > 0 && (
        <div className="branch-inquiry-print mt-4 p-3">
          <div className="d-flex align-items-center mb-3">
            {logo && (
              <img
                src={logo}
                alt="School logo"
                style={{ width: 90, height: 90, objectFit: "contain" }}
              />
            )}
            <div className="ml-3">
              <h2>{unitName}</h2>
              <h3>
                Branch Monthly Inquiry-to-Admission Ratio
                {month ? ` for ${getMonthName(month)}` : ""}
                {sessionName ? ` (Session ${sessionName})` : ""}
              </h3>
              <div className="d-flex justify-content-between">
                <h5>
                  Branch :-{" "}
                  {branchId === ""
                    ? "All Branches"
                    : branches.find((b) => String(b.id) === String(branchId))
                        ?.branches}
                </h5>
                <h5>Printing Date :- {todayDate()}</h5>
              </div>
            </div>
          </div>
          <div className="table-responsive">
            {reportTable(setExportTableElement)}
          </div>
          <div className="mt-5">
            <ReactApexChart
              options={chartOptions}
              series={chartSeries}
              type="bar"
              height={360}
            />
          </div>
        </div>
      )}

      <div
        ref={componentRef}
        id="printSection"
        className="branch-inquiry-print branch-inquiry-print-only p-3"
        style={{
          position: "fixed",
          left: "-10000px",
          top: 0,
          width: 1200,
          visibility: "hidden",
        }}
      >
        <div id="tableboot">
          <div className="p-3" style={{ display: "flex" }}>
            <img style={{ height: 120, width: 130 }} src={logo} alt="logo" />

            <div className="row ml-4">
              <h1>{unitName}</h1>
              <h3>
                Branch Monthly Inquiry-to-Admission Ratio
                {month ? ` for ${getMonthName(month)}` : ""}
                {sessionName ? ` (Session ${sessionName})` : ""}
              </h3>
              <div className="d-flex justify-content-between">
                <h5>
                  Branch :-{" "}
                  {branchId === ""
                    ? "All Branches"
                    : branches.find((b) => String(b.id) === String(branchId))
                        ?.branches}
                </h5>
                <h5>Printing Date :- {todayDate()}</h5>
              </div>
            </div>
          </div>

          <table
            className="table mb-0"
            style={{ color: "#111", width: "100%" }}
          >
            <thead>
              <tr>
                <th
                  rowSpan="2"
                  className="text-center align-middle"
                  style={{
                    minWidth: 110,
                    fontSize: "16px",
                    border: "1px solid black",
                    padding: "10px",
                    whiteSpace: "normal",
                  }}
                >
                  Months
                </th>
                <th
                  colSpan={visibleBranches.length}
                  className="text-center"
                  style={{
                    fontSize: "16px",
                    border: `1px solid black`,
                    padding: "10px",
                    whiteSpace: "normal",
                  }}
                >
                  Inquiries
                </th>
                <th
                  colSpan={visibleBranches.length}
                  className="text-center"
                  style={{
                    fontSize: "16px",
                    border: `1px solid black`,
                    padding: "10px",
                    whiteSpace: "normal",
                  }}
                >
                  Admissions
                </th>
              </tr>
              <tr>
                {visibleBranches.map((branch) => (
                  <th
                    key={`inquiry-${branch.id}`}
                    className="text-center"
                    style={{
                      border: "1px solid black",
                      padding: "10px",
                      whiteSpace: "normal",
                      fontSize: "14px",
                    }}
                  >
                    {branch.name}
                  </th>
                ))}
                {visibleBranches.map((branch) => (
                  <th
                    key={`admission-${branch.id}`}
                    className="text-center"
                    style={{
                      border: "1px solid black",
                      padding: "10px",
                      whiteSpace: "normal",
                      fontSize: "14px",
                    }}
                  >
                    {branch.name}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {reportData.map((monthRecord, index) => (
                <tr key={`${monthRecord.month}-${index}`}>
                  <th
                    className="text-center"
                    style={{
                      border: "1px solid black",
                      padding: "1px",
                      whiteSpace: "normal",
                      fontSize: "14px",
                    }}
                  >
                    {monthRecord.month}
                  </th>
                  {visibleBranches.map((branch) => (
                    <td
                      key={`inq-${index}-${branch.id}`}
                      className="text-center"
                      style={{
                        border: "1px solid black",
                        padding: "1px",
                        whiteSpace: "normal",
                        fontSize: "14px",
                      }}
                    >
                      {Number(
                        getBranchRecord(monthRecord, branch.id)
                          .total_inquiries || 0,
                      )}
                    </td>
                  ))}
                  {visibleBranches.map((branch) => (
                    <td
                      key={`adm-${index}-${branch.id}`}
                      className="text-center"
                      style={{
                        border: "1px solid black",
                        padding: "1px",
                        whiteSpace: "normal",
                        fontSize: "14px",
                      }}
                    >
                      {Number(
                        getBranchRecord(monthRecord, branch.id)
                          .total_converted || 0,
                      )}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
            <tr style={{ background: "#EBEDF3", fontWeight: "bold" }}>
              <th
                className="text-center"
                style={{
                  border: "1px solid black",
                  padding: "10px",
                  whiteSpace: "normal",
                  fontSize: "14px",
                }}
              >
                Total
              </th>
              {branchTotals.map((total, index) => (
                <td
                  key={`total-inquiries-${visibleBranches[index].id}`}
                  className="text-center"
                  style={{
                    border: "1px solid black",
                    padding: "10px",
                    whiteSpace: "normal",
                    fontSize: "14px",
                  }}
                >
                  {total.inquiries}
                </td>
              ))}
              {branchTotals.map((total, index) => (
                <td
                  key={`total-admissions-${visibleBranches[index].id}`}
                  className="text-center"
                  style={{
                    border: "1px solid black",
                    padding: "10px",
                    whiteSpace: "normal",
                    fontSize: "14px",
                  }}
                >
                  {total.converted}
                </td>
              ))}
            </tr>
            <tr style={{ fontWeight: "bold" }}>
              <th
                colSpan={visibleBranches.length + 1}
                className="text-center"
                style={{
                  border: "1px solid black",
                  padding: "10px",
                  fontSize: "14px",
                  whiteSpace: "normal",
                }}
              >
                Conversion Ratio
              </th>
              {branchTotals.map((total, index) => (
                <td
                  key={`ratio-${visibleBranches[index].id}`}
                  className="text-center"
                  style={{
                    border: "1px solid black",
                    padding: "10px",
                    whiteSpace: "normal",
                    fontSize: "14px",
                  }}
                >
                  {conversionRatio(total)}
                </td>
              ))}
            </tr>
          </table>
        </div>
      </div>
    </Paper>
  );
};

export default BranchMonthlyInquiries;
